import React from 'react';
import { CheckCircle, AlertTriangle, Download, Send, BarChart2 } from 'lucide-react';
interface ReportSummaryProps {
  type: string;
  onFinish: () => void;
}
export const ReportSummary: React.FC<ReportSummaryProps> = ({
  type,
  onFinish
}) => {
  return <div className="p-4 space-y-6" data-id="element-283">
      <div className="flex justify-between items-center" data-id="element-284">
        <div data-id="element-285">
          <h2 className="text-lg font-semibold text-gray-900 mb-1" data-id="element-286">
            Closing Summary
          </h2>
          <p className="text-sm text-gray-500" data-id="element-287">September 30, 2025 • 9:15 PM</p>
        </div>
        <div className="bg-green-100 text-green-800 px-3 py-1 rounded-full text-sm font-medium" data-id="element-288">
          Approved
        </div>
      </div>
      <div className="bg-white rounded-lg shadow p-4 space-y-4" data-id="element-289">
        <div className="flex items-center space-x-3 pb-3 border-b border-gray-200" data-id="element-290">
          <BarChart2 className="w-5 h-5 text-blue-600" data-id="element-291" />
          <h3 className="text-base font-medium text-gray-900" data-id="element-292">
            AI-Generated Summary
          </h3>
        </div>
        <div className="text-sm text-gray-700 space-y-3" data-id="element-293">
          <p data-id="element-294">
            The store was successfully closed on September 30, 2025 at 9:15 PM.
            All security checks were completed and verified with photo evidence.
          </p>
          <p data-id="element-295">
            <span className="font-medium" data-id="element-296">Cash Reconciliation:</span> A variance
            of $5.25 was identified in Register #1 and approved by the manager.
            The reason provided was "miscounted bills during rush hour."
          </p>
          <p data-id="element-297">
            <span className="font-medium" data-id="element-298">Inventory:</span> 2 items were not
            scanned during the HVM transfer process. Manager noted these items
            were already secured in the safe earlier in the day.
          </p>
          <p data-id="element-299">
            <span className="font-medium" data-id="element-300">Notable Events:</span> Register #2
            showed higher than average voids today (12 voids vs. typical 3-5).
            Recommend additional review of transaction logs.
          </p>
        </div>
      </div>
      <div className="bg-white rounded-lg shadow overflow-hidden" data-id="element-301">
        <div className="p-4 border-b border-gray-200" data-id="element-302">
          <h3 className="text-base font-medium text-gray-900" data-id="element-303">
            Task Completion Summary
          </h3>
        </div>
        <div className="divide-y divide-gray-200" data-id="element-304">
          <div className="flex items-center justify-between p-4" data-id="element-305">
            <div className="flex items-center" data-id="element-306">
              <CheckCircle className="w-5 h-5 text-green-500 mr-3" data-id="element-307" />
              <span className="text-sm text-gray-900" data-id="element-308">Security Checklist</span>
            </div>
            <span className="text-xs text-gray-500" data-id="element-309">Completed at 8:45 PM</span>
          </div>
          <div className="flex items-center justify-between p-4" data-id="element-310">
            <div className="flex items-center" data-id="element-311">
              <AlertTriangle className="w-5 h-5 text-yellow-500 mr-3" data-id="element-312" />
              <span className="text-sm text-gray-900" data-id="element-313">Cash Reconciliation</span>
            </div>
            <span className="text-xs text-gray-500" data-id="element-314">Completed at 9:02 PM</span>
          </div>
          <div className="flex items-center justify-between p-4" data-id="element-315">
            <div className="flex items-center" data-id="element-316">
              <AlertTriangle className="w-5 h-5 text-yellow-500 mr-3" data-id="element-317" />
              <span className="text-sm text-gray-900" data-id="element-318">HVM Transfer</span>
            </div>
            <span className="text-xs text-gray-500" data-id="element-319">Completed at 8:58 PM</span>
          </div>
        </div>
      </div>
      <div className="space-y-3" data-id="element-320">
        <button className="w-full flex items-center justify-center bg-white border border-gray-300 text-gray-700 py-3 rounded-lg font-medium hover:bg-gray-50 transition-colors" data-id="element-321">
          <Download className="w-4 h-4 mr-2" data-id="element-322" />
          Download Full Report (PDF)
        </button>
        <button className="w-full flex items-center justify-center bg-white border border-gray-300 text-gray-700 py-3 rounded-lg font-medium hover:bg-gray-50 transition-colors" data-id="element-323">
          <Send className="w-4 h-4 mr-2" data-id="element-324" />
          Email Report
        </button>
        <button onClick={onFinish} className="w-full bg-blue-600 text-white py-3 rounded-lg font-medium hover:bg-blue-700 transition-colors" data-id="element-325">
          Return to Dashboard
        </button>
      </div>
    </div>;
};